//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Represents the Invalid Reason for address. */
export const AddressInvalidReason = {
    /** None */
    None: 0,

    /** Not Found */
    NotFound: 1,

    /** Vacant */
    Vacant: 2
} as const;

/** Represents the Invalid Reason for address. */
export const AddressInvalidReasonDescription: Record<number, string> = {
    0: "None",

    1: "Not Found",

    2: "Vacant"
};

/** Represents the Invalid Reason for address. */
export type AddressInvalidReason = typeof AddressInvalidReason[keyof typeof AddressInvalidReason];
